"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Text = _interopRequireDefault(require("../../Text")),
    _ToolTip = _interopRequireDefault(require("../../ToolTip"));

require("../styles/_button.scss");

var TYPE_PROPS = {
  PRIMARY: {
    typeClass: "button--primary",
    iconColour: "white"
  },
  SECONDARY: {
    typeClass: "button--secondary",
    iconColour: "white"
  },
  TERTIARY: {
    typeClass: "button--tertiary",
    iconColour: "denim"
  }
};

function getButtonContent(a) {
  return a ? "string" == typeof a || "number" == typeof a ? _react["default"].createElement(_Text["default"], {
    button: !0
  }, a) : a : null;
}

function getDecorator(a, b, c) {
  return a ? _react["default"].createElement("div", {
    className: "button__content__decorator"
  }, "string" == typeof a ? _react["default"].createElement(_Icon["default"], {
    key: "decorator-icon",
    className: "button__content__decorator__icon",
    name: a,
    color: b,
    size: c || 15
  }) : a) : null;
}

function Button(a) {
  var b = a.disabled,
      c = a.className,
      d = a.busy,
      e = a.children,
      f = a.type,
      g = void 0 === f ? "PRIMARY" : f,
      h = a.prefix,
      i = a.prefixSize,
      j = a.hasMenuIcon,
      k = a.tooltipId,
      l = a.tooltipLabel,
      m = a.tooltipPlace,
      n = a.tooltipClass,
      o = a.onClick,
      p = (0, _objectWithoutProperties2["default"])(a, ["disabled", "className", "busy", "children", "type", "prefix", "prefixSize", "hasMenuIcon", "tooltipId", "tooltipLabel", "tooltipPlace", "tooltipClass", "onClick"]);
  TYPE_PROPS[g] || console.warn("The button type (".concat(g, ") doesn't exist. Falling back to PRIMARY."));
  var q = getButtonContent(e),
      r = h && !q,
      s = r ? TYPE_PROPS.TERTIARY : TYPE_PROPS[g] || TYPE_PROPS.PRIMARY,
      t = s.typeClass,
      u = s.iconColour,
      v = b ? "nevada" : u,
      w = getDecorator(h, v, r ? 20 : i),
      x = j && getDecorator("arrowdown", v, 10);
  return _react["default"].createElement(_ToolTip["default"], {
    id: k,
    label: l,
    place: m,
    className: n
  }, _react["default"].createElement("button", (0, _extends2["default"])({
    className: (0, _classnames["default"])("button", t, {
      "button--disabled": b,
      "button--busy": d,
      "button--icon-only": r
    }, c),
    type: "button",
    onClick: b || d ? void 0 : o
  }, p), d ? _react["default"].createElement("div", {
    className: "button--busy__icon"
  }, _react["default"].createElement(_Icon["default"], {
    name: "shootstagrad",
    color: b ? "black" : u,
    spin: !0
  })) : null, _react["default"].createElement("div", {
    className: "button__content"
  }, w, q, x)));
}

Button.defaultProps = {
  disabled: !1,
  className: "",
  busy: !1,
  children: null
};

var _default = (0, _react.memo)(Button);

exports["default"] = _default;